import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { getQueryParams } from "@/utils/filters";
import { tagReferralPath } from "@/utils/logRocketUtils";

import MemberAgreement from "./components/MemberAgreement";
import SetPassword from "./components/SetPassword";

const AccountSetupWorkflow = (props) => {
  const [password, setPassword] = useState(null);
  const [sectionToShow, setSectionToShow] = useState("set_password");

  useEffect(() => {
    tagReferralPath("patient_auto_signup");
  }, []);

  const baseProps = {
    id: getQueryParams("id", props.location.id),
    password: password,
    setPassword: setPassword,
    setSectionToShow: setSectionToShow,
  };

  const accountLookUpSections = {
    member_agreement: <MemberAgreement {...baseProps} />,
    set_password: <SetPassword {...baseProps} />,
  };

  return (
    <>
      <div className="p-lg-5 p-3">{accountLookUpSections[sectionToShow]}</div>
    </>
  );
};

export default withRouter(AccountSetupWorkflow);
